import { DocumentSettings } from "../../../../models/document-settings";
import { FormType, DocumentStructureType, DocumentStructureHebType, isDocumentStructureType } from "../../../../models/types";
import { Params } from "./DocumentFieldsStructure.types";

export function setParams(pathname: string): Params{
    const segments: string[] = pathname.split("/").filter(Boolean);

    console.log("Segments", segments);

    const formType: FormType = segments[segments.length-1] === "search"? "search" : segments[segments.length-1] === "browse"? "browse" : "form";
    const documentStructureType: DocumentStructureType | undefined = getDocumentStructureType(segments);
    const documentStructureHebType: DocumentStructureHebType | undefined = getDocumentStructureHebType(documentStructureType); 

    const params: Params = {
        formType,
        documentStructureType,    
        documentStructureHebType
    }

    return params;
}

export function getDocumentStructureType(segments: string[]): DocumentStructureType | undefined {

    const first = segments[0];
    const last = segments[segments.length - 1];


    if(isDocumentStructureType(first)){
        return first;
    }

    else if(isDocumentStructureType(last)){
        return last;
    }
}

export function getDocumentStructureHebType(DocumentStructureType: DocumentStructureType | undefined): DocumentStructureHebType | undefined {

    switch (DocumentStructureType) {
        case "account":
            return "חשבון";
        case "item":
            return "פריט";
        case "work":
            return "עבודה";
        case "car":
            return "רכב";
    }
}

// function getAccountTypeForHeader(type?: DocumentStructureType): string{
//     switch (type) {
//         case "לקוח-ספק":
//             return "חשבון";

//         default:
//             return type ?? "";
//     }
// }

export function getHeaderName(params: Params, documentSettings?: DocumentSettings): string {
    console.log("getHeaderName documentSettings ",documentSettings);
    switch (params.formType) {
        case "search":
            return "הגדרת מבנה חיפוש מסמכים";
        case "browse":
            return "הגדרת מבנה דפדוף מסמכים";
        case "form":
            return `הגדרת מבנה ${params.documentStructureHebType ?? ""} במסמך ${documentSettings?.name ?? ""}`;
        default:
            break;
    }

    return "";
}